import React from 'react';

const SvgTr = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="TR_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="TR_svg__b" fill="#fff">
        <use xlinkHref="#TR_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#TR_svg__a" />
      <path fill="#E92434" mask="url(#TR_svg__b)" d="M0 0h28v20H0z" />
      <path
        fill="#FFF"
        mask="url(#TR_svg__b)"
        d="M18.686 10.812l-1.568 1.118.579-1.836-1.547-1.146 1.924-.017.612-1.825.611 1.825 1.925.017-1.547 1.146.578 1.836-1.567-1.118z"
      />
      <path
        d="M17.403 6.316a5.21 5.21 0 0 0-3.07-.983c-2.761 0-5 2.09-5 4.667s2.239 4.667 5 4.667a5.21 5.21 0 0 0 3.07-.983 6 6 0 1 1 0-7.368z"
        fill="#FFF"
        mask="url(#TR_svg__b)"
      />
    </g>
  </svg>
);

export default SvgTr;
